export enum HeadingSize {
  BIG = 'Big',
  SMALL = 'Small',
}

export interface IHeadingSize {
  id: number;
  name: HeadingSize;
}
